import React, { useState } from 'react';
import { Box, Typography, TextField, Button, FormControl, InputLabel, Select, MenuItem, RadioGroup, FormControlLabel, Radio, Container, Link, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar';
import { useAuth } from '../contexts/AuthContext';

const PersonalizedMantraPage = () => {
  const { user } = useAuth();
  const [form, setForm] = useState({
    name: '',
    energy: '',
    mood: '',
    goal: '',
    email: '',
    phone: '',
    consult: 'no',
  });
  const navigate = useNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: theme.palette.background.default, py: 0 }}>
      <NavBar user={user} />
      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Link onClick={() => navigate('/products')} sx={{ cursor: 'pointer', fontWeight: 600, color: 'primary.main', mb: 2, display: 'inline-block' }}>
          ← Back to Shop
        </Link>
        <Box
          sx={{
            bgcolor: theme.palette.background.paper,
            borderRadius: 4,
            boxShadow: 8,
            p: { xs: 3, sm: 5 },
            display: 'grid',
            gridTemplateRows: 'auto auto 1fr auto',
            rowGap: 3,
          }}
        >
          <Typography variant="h4" fontWeight={700} sx={{ fontFamily: 'Playfair Display, serif', color: 'primary.main', mb: 1 }}>
            Your Personalized Mantra
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            Discover the healing power of voice. Let Karen create a custom mantra just for you, based on your energy and intention.<br/>
            Choose between completing the form or adding a 15-minute voice consultation. Mantras will be delivered as high-quality audio (8–15 min) within 10 business days.
          </Typography>
          <Box
            component="form"
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
              gap: 2,
              mb: 2,
            }}
            noValidate
            autoComplete="off"
          >
            <TextField label="Name" name="name" value={form.name} onChange={handleChange} fullWidth />
            <FormControl fullWidth>
              <InputLabel>Energy Level</InputLabel>
              <Select name="energy" value={form.energy} label="Energy Level" onChange={handleChange}>
                <MenuItem value="low">Low</MenuItem>
                <MenuItem value="medium">Medium</MenuItem>
                <MenuItem value="high">High</MenuItem>
              </Select>
            </FormControl>
            <TextField label="Mood" name="mood" value={form.mood} onChange={handleChange} fullWidth />
            <TextField label="What do you hope to achieve?" name="goal" value={form.goal} onChange={handleChange} fullWidth multiline rows={2} sx={{ gridColumn: { xs: '1', sm: '1 / span 2' } }} />
            <TextField label="Email" name="email" value={form.email} onChange={handleChange} fullWidth type="email" />
            <TextField label="Phone Number" name="phone" value={form.phone} onChange={handleChange} fullWidth type="tel" />
            <FormControl component="fieldset" sx={{ gridColumn: { xs: '1', sm: '1 / span 2' } }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Would you like a 15-minute consultation?</Typography>
              <RadioGroup row name="consult" value={form.consult} onChange={handleChange}>
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Box>
          <Box
            sx={{
              bgcolor: isDark ? 'rgba(144,224,239,0.08)' : 'rgba(69,123,157,0.07)',
              borderRadius: 2,
              p: 2,
              textAlign: 'center',
              fontStyle: 'italic',
              color: 'primary.main',
              fontWeight: 500,
              mb: 2
            }}
          >
            Stripe payment integration coming soon.
          </Box>
          <Button variant="contained" color="primary" size="large" sx={{ borderRadius: 999, fontWeight: 600, mt: 2 }}>
            Submit & Pay
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default PersonalizedMantraPage; 